module.exports = __webpack_public_path__ + "h5/img/f1.b4c46684.jpg";